import { render, staticRenderFns } from "./ImportDxf.vue?vue&type=template&id=663dbc73&scoped=true&"
import script from "./ImportDxf.vue?vue&type=script&lang=js&"
export * from "./ImportDxf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663dbc73",
  null
  
)

export default component.exports